import { When } from 'react-if'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { slugs } from '@/constants/slugs'
import { useAboutContext } from '@/contexts/AboutContext'
import { BeforeYouLeaveProvider } from '@/contexts/BeforeYouLeaveContext'
import { BeforeYouLeaveModal } from '@/molecules/BeforeYouLeaveModal'
import { FaqAccordion } from '@/organisms/FaqAccordion'
import { GuildMembershipBanner } from '@/organisms/GuildMembershipBanner'
import { contentfulFaqLocations, useProjectFaqs } from '@/services/FaqService'
import { useGuildMember } from '@/services/GuildUserService'
import { useLocale } from '@/utils/LocaleUtil'
import { ExplainerSection } from './ExplainerSection'
import { useExplainerContent } from './ExplainerSection/ExplainerContent'
import { HeroSection } from './HeroSection'
import { InfoSection } from './InfoSection'
import { OurHistorySection } from './OurHistorySection/OurHistorySection'
import { OurMissionSection } from './OurMissionSection'
import { OurTitlesSection } from './OurTitlesSection'
import { SubmitSection } from './SubmitSection'

export const AboutView = () => {
  const { locale } = useLocale()
  const { isGuildMember } = useGuildMember()
  const explainerContent = useExplainerContent()
  const { guildMembershipNumbers } = useAboutContext()
  const { faqs, loadingProjectFaqs } = useProjectFaqs({
    locale,
    preview: false,
    projectSlug: slugs.angelStudios,
    location: contentfulFaqLocations.about,
  })

  return (
    <BeforeYouLeaveProvider>
      <main className="text-white">
        <HeroSection />
        <OurMissionSection />
        <ExplainerSection {...explainerContent[0]!} />
        <GuildMembershipBanner guildMembershipNumbers={guildMembershipNumbers} isGuildMember={isGuildMember} />
        <ExplainerSection {...explainerContent[1]!} />
        <InfoSection />
        <ExplainerSection {...explainerContent[2]!} />
        <OurHistorySection />
        <OurTitlesSection />
        <SubmitSection />
        <div className="bg-black py-40">
          <When condition={!loadingProjectFaqs}>
            <PaddedContainer>
              <FaqAccordion faqs={faqs} />
            </PaddedContainer>
          </When>
        </div>
      </main>
      <BeforeYouLeaveModal />
    </BeforeYouLeaveProvider>
  )
}
